export enum GroupChatConversationType {
  PublicGroup = 'PublicGroup',
  PrivateUsers = 'PrivateUsers',
  PropipeAi = 'PrivatePropipeAi',
}

export enum GroupChatMessageType {
  Normal = 'Normal',
  UserLeft = 'UserLeft',
}
